export const categories = {
  "FD": {
    "id": "FD",
    "slug": "food",
    "image-placeholder": require('@/assets/categories/alimentaire.jpg'),
    "icon": "fas fa-utensils"
  },
  "AN": {
    "id": "AN",
    "slug": "animals",
    "image-placeholder": require('@/assets/categories/animaux.jpg'),
    "icon": "fas fa-paw"
  },
  "EN": {
    "id": "EN",
    "slug": "aee",
    "image-placeholder": require('@/assets/categories/arts.jpg'),
    "icon": "fas fa-theater-masks"
  },
  "CL": {
    "id": "CL",
    "slug": "collectors",
    "image-placeholder": require('@/assets/categories/collectionneurs.jpg'),
    "icon": "fas fa-coins"
  },
  "HL": {
    "id": "HL",
    "slug": "hh",
    "image-placeholder": require('@/assets/categories/coupdepouce.jpg'),
    "icon": "fas fa-people-carry"
  },
    "AT": {
    "id": "AT",
    "slug": "adminit",
    "image-placeholder": require('@/assets/categories/administrative.jpg'),
    "icon": "fas fa-list"
  },
  "DY": {
    "id": "DY",
    "slug": "diy",
    "image-placeholder": require('@/assets/categories/diy.jpg'),
    "icon": "fas fa-toolbox"
  },
  "BT": {
    "id": "BT",
    "slug": "beauty",
    "image-placeholder": require('@/assets/categories/beauty.jpg'),
    "icon": "fas fa-smile-wink"
  },
  "HE": {
    "id": "HE",
    "slug": "health",
    "image-placeholder": require('@/assets/categories/health.jpg'), 
    "icon": "fas fa-medkit"
  },
  "EY": {
    "id": "EY",
    "slug": "energy",
    "image-placeholder": require('@/assets/categories/energy.jpg'), 
    "icon": "fas fa-fire"
  },
  "CH": {
    "id": "CH",
    "slug": "childhood",
    "image-placeholder": require('@/assets/categories/enfance.jpg'),
    "icon": "fas fa-child"
  },
  "CO": {
    "id": "CO",
    "slug": "clothes",
    "image-placeholder": require('@/assets/categories/clothes.jpg'),
    "icon": "fas fa-tshirt"
  },
  "IT": {
    "id": "IT",
    "slug": "it",
    "image-placeholder": require('@/assets/categories/it.jpg'),
    "icon": "fas fa-tv"
  },
  "CS": {
    "id": "CS",
    "slug": "cs",
    "image-placeholder": require('@/assets/categories/code.jpg'),
    "icon": "fas fa-laptop-code"
  },
  "GD": {
    "id": "GD",
    "slug": "garden",
    "image-placeholder": require('@/assets/categories/jardin.jpg'),
    "icon": "fas fa-seedling"
  },
  "HS": {
    "id": "HS",
    "slug": "house",
    "image-placeholder": require('@/assets/categories/maison.jpg'),
    "icon": "fas fa-home"
  },
  "EQ": {
    "id": "EQ",
    "slug": "tools",
    "image-placeholder": require('@/assets/categories/tools.jpg'), 
    "icon": "fas fa-tools"
  },
  "HD": {
    "id": "HD",
    "slug": "holidays",
    "image-placeholder": require('@/assets/categories/holidays.jpg'),
    "icon": "fas fa-umbrella-beach"
  },
  "BK": {
    "id": "BK",
    "slug": "book",
    "image-placeholder": require('@/assets/categories/books.jpg'),
    "icon": "fas fa-book"
  },
    "MD": {
    "id": "MD",
    "slug": "media",
    "image-placeholder": require('@/assets/categories/media.jpg'),
    "icon": "fas fa-compact-disc"
  },
  "SP": {
    "id": "SP",
    "slug": "sport",
    "image-placeholder": require('@/assets/categories/sports.jpg'),
    "icon": "fas fa-futbol"
  },
  "TS": {
    "id": "TS",
    "slug": "transport",
    "image-placeholder": require('@/assets/categories/transport_delivery.jpg'),
    "icon": "fas fa-truck-loading"
  },
  "VE": {
    "id": "VE",
    "slug": "vehicle",
    "image-placeholder": require('@/assets/categories/means_of_transport.jpg'), 
    "icon": "fas fa-car-side"
  },
  "PR": {
    "id": "PR",
    "slug": "publicresource",
    "image-placeholder": require('@/assets/categories/publicresource.jpg'), 
    "icon": "fas fa-city"
  },
  "OT": {
    "id": "OT",
    "slug": "other",
    "image-placeholder": require('@/assets/categories/other.jpg'),
    "icon": "fas fa-star"
  }
};
